import { getTestShortName } from "./testNameDisplay";

export const formatFullTestNames = (fullTestNames: string): string => {
  if (!fullTestNames) return "";

  return fullTestNames
    .split(",")
    .map((part) => getTestShortName(part))
    .join(", ");
};
